/* Copyright 2021, Milkdown by Mirone. */
import { commandsCtx } from '@milkdown/core';
import { ModifyInlineMath } from '@milkdown/plugin-math';
import { ModifyImage, ModifyLink } from '@milkdown/preset-commonmark';
import { findChildren } from '@milkdown/utils';
import { elementIsTag } from './element';
export const modifyLink = (ctx) => (e) => {
    const { target } = e;
    if (!(target instanceof HTMLElement)) {
        return () => true;
    }
    if (elementIsTag(target, 'input')) {
        target.focus();
        return () => false;
    }
    const parent = target.parentNode;
    if (!parent)
        return () => false;
    const inputEl = Array.from(parent.children).find((el) => el.tagName === 'INPUT');
    if (!(inputEl instanceof HTMLInputElement))
        return () => false;
    return ctx.get(commandsCtx).call(ModifyLink, inputEl.value);
};
export const modifyInlineMath = (ctx) => (e) => {
    const { target } = e;
    if (!(target instanceof HTMLElement)) {
        return () => true;
    }
    const parent = target.parentNode;
    if (!parent)
        return () => false;
    const inputEl = Array.from(parent.children).find((el) => el.tagName === 'INPUT');
    if (!(inputEl instanceof HTMLInputElement))
        return () => false;
    return ctx.get(commandsCtx).call(ModifyInlineMath, inputEl.value);
};
export const modifyImage = (ctx) => (e) => {
    const { target } = e;
    if (!(target instanceof HTMLElement)) {
        return () => true;
    }
    if (elementIsTag(target, 'input')) {
        target.focus();
        return () => false;
    }
    const parent = target.parentNode;
    if (!parent)
        return () => false;
    const inputEl = Array.from(parent.children).find((el) => el.tagName === 'INPUT');
    if (!(inputEl instanceof HTMLInputElement))
        return () => false;
    return ctx.get(commandsCtx).call(ModifyImage, inputEl.value);
};
export const updateLinkView = (view, $) => {
    const { marks } = view.state.schema;
    const { firstChild, lastElementChild } = $;
    if (!(firstChild instanceof HTMLInputElement) || !(lastElementChild instanceof HTMLButtonElement))
        return;
    const { selection } = view.state;
    let node;
    view.state.doc.nodesBetween(selection.from, selection.to, (n) => {
        if (marks.link.isInSet(n.marks)) {
            node = n;
            return false;
        }
        return;
    });
    if (!node)
        return;
    const mark = node.marks.find((m) => m.type === marks.link);
    if (!mark)
        return;
    const value = mark.attrs.href;
    firstChild.value = value;
    if (!value) {
        lastElementChild.classList.add('disable');
        return;
    }
    if (lastElementChild.classList.contains('disable')) {
        lastElementChild.classList.remove('disable');
    }
};
export const updateInlineMathView = (view, $) => {
    var _a;
    const { nodes } = view.state.schema;
    const { firstChild, lastElementChild } = $;
    if (!(firstChild instanceof HTMLInputElement) || !(lastElementChild instanceof HTMLButtonElement))
        return;
    const node = (_a = findChildren((node) => node.type === nodes.math_inline)(view.state.selection.$from.node())[0]) === null || _a === void 0 ? void 0 : _a.node;
    if (!node)
        return;
    const value = node.attrs.value;
    firstChild.value = value;
    if (!value) {
        lastElementChild.classList.add('disable');
        return;
    }
    if (lastElementChild.classList.contains('disable')) {
        lastElementChild.classList.remove('disable');
    }
};
export const updateImageView = (view, $) => {
    var _a;
    const { nodes } = view.state.schema;
    const { firstChild, lastElementChild } = $;
    if (!(firstChild instanceof HTMLInputElement) || !(lastElementChild instanceof HTMLButtonElement))
        return;
    const node = (_a = findChildren((node) => node.type === nodes.image)(view.state.selection.$from.node())[0]) === null || _a === void 0 ? void 0 : _a.node;
    if (!node)
        return;
    const value = node.attrs.src;
    firstChild.value = value;
    if (!value) {
        lastElementChild.classList.add('disable');
        return;
    }
    if (lastElementChild.classList.contains('disable')) {
        lastElementChild.classList.remove('disable');
    }
};
//# sourceMappingURL=input.js.map